import { render, staticRenderFns } from "./TalkBasicAskOpinion.vue?vue&type=template&id=3c06e528&scoped=true&"
import script from "./TalkBasicAskOpinion.vue?vue&type=script&lang=ts&"
export * from "./TalkBasicAskOpinion.vue?vue&type=script&lang=ts&"
import style0 from "./TalkBasicAskOpinion.vue?vue&type=style&index=0&id=3c06e528&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c06e528",
  null
  
)

export default component.exports